const CNTRY = 'CNTRY';
const FULL = 'FULL';
const POSTALCNTRY = 'POSTALCNTRY';

export { CNTRY, FULL, POSTALCNTRY };
